import type { RouteObject } from "react-router-dom";
import { DuesPage } from "./DuesPage";

export const routes: RouteObject[] = [{ path: "dues", element: <DuesPage /> }];
